import Vue from "vue";
import VueRouter from "vue-router";
import { StorageHelper } from "../common/storageHelper";
import {Utils} from "../common/utils";
import Clipboard from 'v-clipboard'
import vueCountryRegionSelect from 'vue-country-region-select'

Vue.use(vueCountryRegionSelect);
Vue.use(VueRouter);
Vue.use(Clipboard);

const routes = [
    {
        path: "/reservations",
        name: "reservations",
        meta: { requiresAuth: true },
        component: () => import("../views/Reservations.vue")
    },
    {
        path: "/appointments",
        name: "appointments",
        meta: { requiresAuth: true },
        component: () => import("../views/AppointmentsAdmin.vue")
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/Login.vue")
    },
    {
        path: "/clients",
        name: "clients",
        meta: { requiresAuth: true },
        component: () => import("../views/Clients.vue")
    },
    {
        path: "/calendar",
        name: "calendar",
        alias: "/",
        meta: { requiresAuth: true },
        component: () => import("../views/Calendar.vue")
    },
    {
        path: "/clients/:id",
        name: "client_detail",
        meta: { requiresAuth: true },
        component: () => import("../views/ClientDetail.vue")
    },
    {
        path: "/booking",
        name: "booking",
        meta: { requiresAuth: true },
        component: () => import("../views/Booking.vue")
    },
    {
        path: "/cash_report",
        name: "cash_report",
        meta: { requiresAuth: true },
        component: () => import("../views/CashReport.vue")
    },
    {
        path: "/transactions",
        name: "transactions",
        meta: { requiresAuth: true },
        component: () => import("../views/Transactions.vue")
    },
    {
        path: "/payouts",
        name: "payouts",
        meta: { requiresAuth: true },
        component: () => import("../views/Payouts.vue")
    },
    {
        path: "/payouts/:payout_id",
        name: "payout_detail",
        meta: { requiresAuth: true },
        component: () => import("../views/PayoutDetail.vue")
    },
    {
        path: "/fee_log",
        name: "fee_log",
        meta: { requiresAuth: true },
        component: () => import("../views/FeeLog.vue")
    },
    {
        path: "/analytics",
        name: "analytics",
        meta: { requiresAuth: true },
        component: () => import("../views/Analytics.vue")
    },
    {
        path: "/rates",
        name: "rates",
        meta: { requiresAuth: true },
        component: () => import("../views/Rates.vue")
    },
    {
        path: "/rates/:id",
        name: "rate_detail",
        meta: { requiresAuth: true },
        component: () => import("../views/RateDetail.vue")
    },
    {
        path: "/subscriptions/type",
        name: "subscriptions_type",
        meta: { requiresAuth: true },
        component: () => import("../views/SubscriptionsType.vue")
    },
    {
        path: "/subscriptions/type/:id",
        name: "subscriptions_type_detail",
        meta: { requiresAuth: true },
        component: () => import("../views/SubscriptionsTypeDetail.vue")
    },
    {
        path: "/events",
        name: "events",
        meta: { requiresAuth: true },
        component: () => import("../views/Events.vue")
    },
    {
        path: "/content",
        name: "content",
        meta: { requiresAuth: true },
        component: () => import("../views/Content.vue")
    },
    {
        path: "/content/videos",
        name: "videos",
        meta: { requiresAuth: true },
        component: () => import("../views/Videos.vue")
    },
    {
        path: "/content/videos/:video_id",
        name: "video_detail",
        meta: { requiresAuth: true },
        component: () => import("../views/VideoDetail.vue")
    },
    {
        path: "/marketing",
        name: "marketing",
        meta: { requiresAuth: true },
        component: () => import("../views/Marketing.vue")
    },
    {
        path: "/marketing/calendar",
        name: "booking_calendar",
        meta: { requiresAuth: true },
        component: () => import("../views/BookingCalendar.vue")
    },
    {
        path: "/marketing/showcases",
        name: "showcases",
        meta: { requiresAuth: true },
        component: () => import("../views/Showcases.vue")
    },
    {
        path: "/marketing/showcases/:showcase_id",
        name: "showcase_detail",
        meta: { requiresAuth: true },
        component: () => import("../views/ShowcaseDetail.vue")
    },


    {
        path: "/showcase/:showcase_fingerprint/checkout",
        name: "showcase_checkout",
        component: () => import("../views/ShowcaseCheckout.vue")
    },

    {
        path: "/showcase/:showcase_fingerprint",
        name: "showcase_consumer",
        component: () => import("../views/ShowcaseConsumer.vue")
    },
    {
        path: "/showcase/:lang/:showcase_fingerprint",
        name: "showcase_consumer_whit_lang",
        component: () => import("../views/ShowcaseConsumer.vue")
    },

    {
        path: "/users",
        name: "users",
        meta: { requiresAuth: true },
        component: () => import("../views/Users.vue")
    },
    {
        path: "/settings",
        name: "settings",
        meta: { requiresAuth: true },
        component: () => import("../views/Settings.vue")
    },
    {
        path: "/developers",
        name: "developers",
        meta: { requiresAuth: true },
        component: () => import("../views/Developers.vue")
    },
    {
        path: "/account",
        name: "account",
        meta: { requiresAuth: true },
        component: () => import("../views/Account.vue")
    },

    {
        path: "/company/:company_username/booking",
        name: "booking_widget",
        component: () => import("../views/AppointmentBookingWidget.vue"),
    },
    {
        path: "/company/:company_id/appointments/booking",
        name: "appointment_booking",
        component: () => import("../views/OldAppointmentBookingWidget.vue")
    },
    {
        path: "/users/activate/:uidb64/:token/",
        name: "activate_user",
        component: () => import("../views/ActivateUser.vue")
    },
    {
        path: "/statement",
        name: "statement",
        meta: { requiresAuth: true },
        component: () => import("../views/Statement.vue")
    },
];

const routerManager = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    linkActiveClass: "active", // active class for non-exact links.
    linkExactActiveClass: "active", // active class for *exact* links.
    routes
});

routerManager.beforeEach((to, from, next) => {
    const authUser = StorageHelper.getUser();
    const token = StorageHelper.getToken();
    if (to.meta.requiresAuth) {
        if (authUser && token) {
            if (to.path === "/") {
                next({name : Utils.getRedirectPageNameByUser(authUser)})
            } else {
                next();
            }
        } else {
            next({ name: "login" });
        }
    } else {
        if (to.name === "login" && authUser && token) {
            next({name : Utils.getRedirectPageNameByUser(authUser)})
        } else {
            next();
        }
    }
});

export default routerManager;
